import { BaseDataTransferObject } from '../../../shared/models/base-data-transfer-object';

export class RequisitionBillingInfo extends BaseDataTransferObject {
    public requisitionId?: number;
    public patientBillingInformationId: number = -1;
    public position: number = 1;
}
